// extracted by mini-css-extract-plugin
module.exports = {"pagination":"BlogPagination_pagination__1o60T","active":"BlogPagination_active__aVKXz","disabled":"BlogPagination_disabled__2B5VV"};